const _defaultState = () => ({
    user_values: null,
    transactions: null,
    transactions_summary: null,
    partners: null,
});

const state = _defaultState();

const mutations = {
    SET_USER_VALUES(state, values) {
        state.user_values = values;
    },
    SET_TRANSACTIONS(state, { data, summary }) {
        state.transactions = data;
        state.transactions_summary = summary ?? null;
    },
    SET_PARTNERS(state, partners) {
        state.partners = partners;
    },
    RESET_ADMIN_DASHBOARD_STATE(state) {
        Object.assign(state, _defaultState());
    },
};

const getters = {
    get_user_values(state) {
        return state.user_values;
    },
    get_pending_users(state) {
        if (!state.user_values) return null;
        return state.user_values.filter(u => u.balance > 0);
    },
    get_total_pending(state) {
        if (!state.user_values) return 0;
        return state.user_values.filter(u => u.balance > 0).reduce((sum, u) => sum + u.balance, 0);
    },
    get_transactions(state) {
        return state.transactions;
    },
    get_transactions_summary(state) {
        return state.transactions_summary;
    },
    get_partners(state) {
        return state.partners;
    },
    get_partners_weighings(state) {
        if (!state.partners) return 0;
        return state.partners.reduce((sum, p) => sum + (p.total_weighings ?? 0), 0);
    },
};

const actions = {
    async fetchUserValues({ commit, rootGetters }) {
        const { ct_admins } = await import('@/controllers/admins');
        const { access_token } = rootGetters['admins_users/get_admin_data'];

        const response = await ct_admins.getUserValues(access_token);
        if (!response.status) throw response.error;

        commit('SET_USER_VALUES', response.data);
        return response.data;
    },

    async fetchUserDetails({ rootGetters }, users_id) {
        const { ct_admins } = await import('@/controllers/admins');
        const { access_token } = rootGetters['admins_users/get_admin_data'];

        const response = await ct_admins.getUserDetails(access_token, users_id);
        if (!response.status) throw response.error;

        return response.data;
    },

    async payUser({ dispatch, rootGetters }, users_id) {
        const { ct_admins } = await import('@/controllers/admins');
        const { access_token } = rootGetters['admins_users/get_admin_data'];

        const response = await ct_admins.payUser(access_token, users_id);
        if (!response.status) throw response.error;

        await dispatch('fetchUserValues');
        return response;
    },

    async fetchTransactions({ commit, rootGetters }, params) {
        const { ct_admins } = await import('@/controllers/admins');
        const { access_token } = rootGetters['admins_users/get_admin_data'];

        const response = await ct_admins.getTransactions(access_token, params);
        if (!response.status) throw response.error;

        // busca sem resultado não traz `summary` — normalizamos aqui
        commit('SET_TRANSACTIONS', { data: response.data ?? [], summary: response.summary });
        return response.data;
    },

    async fetchPartners({ commit, rootGetters }) {
        const { ct_admins } = await import('@/controllers/admins');
        const { access_token } = rootGetters['admins_users/get_admin_data'];

        const response = await ct_admins.getPartners(access_token);
        if (!response.status) throw response.error;

        commit('SET_PARTNERS', response.data);
        return response.data;
    },
};

const admins_dashboard = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};

export default admins_dashboard;
